// extracted by mini-css-extract-plugin
export default {"elective_box":"styles_elective_box__pRe4C"};